export enum Tab {
  SUBJECTS = "subjects",
  QUALIFIERS = "qualifiers",
}

export enum SearchType {
  QUICK = "quick",
}
